
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/physical-damage-protection",
      function () {
        return require("private-next-pages/physical-damage-protection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/physical-damage-protection"])
      });
    }
  